import { useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/modules/ModulesAction";
import { resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { ModuleEditForm } from "./ModuleEditForm";
 
export function ModuleEdit() {
  const dispatch = useDispatch();
  const { actionsLoading, modules, module } = useSelector(
    (state) => ({
      actionsLoading: state.modules.actionsLoading,
      modules: state.modules.entities,
      module: state.modules.module,
    }),
    shallowEqual
  );

  const parentModuleOptions = [{ value: 0, label: "Ana Modül"}];
  modules && modules.forEach(module => {
    if (module.parentId === 0) {
      const option = {
        value: module.id,
        label: module.name
      };      
      parentModuleOptions.push(option);
    }
  });

  const saveModule = (values) => {
    dispatch(actions.saveModule(values)).then((result) => onResult(result));
  };

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => dispatch(actions.getModules()), 2500);
  };

  const btnRef = useRef();  
  const saveModuleClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };
    
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title="Modül Formu">
        <CardHeaderToolbar>            
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => dispatch(actions.getModule())}
          >
            Yeni Modül
          </button>            
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="mt-5">
          <ModuleEditForm
            module={module}
            parentModuleOptions={parentModuleOptions}
            btnRef={btnRef}
            saveModule={saveModule}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveModuleClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}